import { compose, mapProps } from 'recompose';
import { User } from 'user';

import withUser, { WithUserProps } from '../../../../HOCs/withUser';

export type UpdateUserInitialData = { initialData: User };

export default compose<WithUserProps, UpdateUserInitialData>(
  withUser,
  mapProps(({ user: { profile }, ...other }) => ({
    initialData: profile || {},
    ...other
  }))
);
